import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { media, Container, screenSizes } from '../../helpers/styleConstants';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, ButtonIcon } from 'rmwc';
import { Elevation } from 'rmwc/Elevation';
import { Typography } from 'rmwc/Typography';
import { Theme } from 'rmwc/Theme';
import { Icon } from 'rmwc/Icon';
import { signOutUser } from '../../actions/userActions';
import { Text } from '../../components/Text';
import { isTest } from '../../helpers/environment';
import { PlanImpactSingleNoFrame } from '../../components/charts/PlanImpact';
import { wlVar, wlPath } from '../../helpers/whitelabel';
import { feVar } from '../../helpers/frontendExperience';
import { newWindow } from '../../helpers/newWindow';
import { isAutoCreatedEmail } from '../../helpers/stringHelper';
import Header from '../../components/Header';
import { LegalNotices } from '../../components/LegalNotices';
import { ContactFooterFloat, ContactFooterShim } from '../../components/Footer';

import {
  COLLECT_CONTACT_AFTER_ACTION_ITEMS,
  COLLECT_CONTACT_ON_FIRST_ONBOARDING_SCREEN,
  MAGIC_LINK,
} from '../../helpers/constants';

class RequiredTime extends Component {
  render() {
    return (
      <Typography
        use="body1"
        tag="div"
        className="mt-3"
        theme="text-secondary-on-background"
        style={{ display: 'flex', letterSpacing: '0px' }}
      >
        <Icon
          style={{
            verticalAlign: 'middle',
            fontSize: '18px',
            marginBottom: '5px',
            marginRight: '5px',
          }}
        >
          alarm
        </Icon>
        {' Less than 10 minutes'}
      </Typography>
    );
  }
}

class HeroText extends Component {
  render() {
    return (
      <div style={{ ...this.props.style }}>
        <div tag="div" dangerouslySetInnerHTML={{ __html: wlVar('hero_lp') }} />
      </div>
    );
  }
}

class ScoreTeaser extends Component {
  render() {
    return (
      <div style={{ ...this.props.style, background: 'white' }}>
        <div dangerouslySetInnerHTML={{ __html: wlVar('copy_lp_cta_heading') }} />
        <div>
          <div dangerouslySetInnerHTML={{ __html: wlVar('copy_lp_cta_body') }} />
          <Button
            onClick={
              feVar('lp_cta_link') ? () => newWindow(feVar('lp_cta_link'), 'custom_lp_cta_link') : this.props.redirect
            }
            theme="secondary-bg on-secondary"
            style={{
              display: 'block',
              width: '100%',
              height: '45px',
              fontSize: '16px',
              borderRadius: '5px',
            }}
          >
            <ButtonIcon>arrow_forward</ButtonIcon>
            <span dangerouslySetInnerHTML={{ __html: wlVar('copy_lp_cta_button') }} />
          </Button>
        </div>
        <div className="mb-3" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <RequiredTime />
        </div>
      </div>
    );
  }
}

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      screenHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    };
  }

  _signout(e) {
    e.preventDefault();
    this.props.dispatch(signOutUser());
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({
      screenWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      screenHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    });
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  redirect = () => {
    const { user } = this.props;

    let nextPath = '/start';

    this.props.history.push(wlPath(nextPath));
  };

  render() {
    return (
      <div>
        <Header />
        <div
          style={{
            minHeight: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '450px' : '150px',
            maxHeight: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '650px' : '280px',
            height: `${this.state.screenWidth * 41 / 100}px`,
            position: 'relative',
            backgroundImage: `url(${wlVar('landing_image')})`,
            backgroundSize: 'cover',
            backgroundPosition: '15% 36%',
          }}
        >
          {this.state.screenWidth >= screenSizes.tabletLandscapeUp && (
            <Fragment>
              <HeroText
                style={{
                  position: 'absolute',
                  width: '45%',
                  minWidth: '400px',
                  maxWidth: '600px',
                  right: '50%',
                  bottom: 0,
                  padding: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '35px' : '20px',
                }}
              />
              <ScoreTeaser
                screenWidth={this.state.screenWidth}
                style={{
                  position: 'absolute',
                  width: '45%',
                  minWidth: '400px',
                  maxWidth: '600px',
                  left: '50%',
                  bottom: 0,
                  padding: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '35px' : '20px',
                }}
                redirect={this.redirect}
              />
            </Fragment>
          )}
          {this.state.screenWidth < screenSizes.tabletLandscapeUp && (
            <HeroText
              style={{
                position: 'absolute',
                width: '100%',
                maxWidth: '900px',
                bottom: 0,
                padding: '40px',
              }}
            />
          )}
        </div>
        {this.state.screenWidth < screenSizes.tabletLandscapeUp && (
          <div
            className="pt-3"
            style={{
              padding: '0 40px 0 40px',
              maxWidth: '900px',
              margin: 'auto',
              background: 'white',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div style={{ maxWidth: '600px' }}>
              <ScoreTeaser screenWidth={this.state.screenWidth} style={{}} redirect={this.redirect} />
            </div>
          </div>
        )}
        <Theme use="primary-bg" tag="div">
          <div
            className="pt-5 pb-4"
            style={{ background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.59) 0%, rgba(0, 0, 0, 0.32) 50.83%)' }}
          >
            <div
              style={{
                padding: '0 40px 0 40px',
                maxWidth: '900px',
                margin: 'auto',
                color: 'white',
                display: 'flex',
                ...(this.state.screenWidth >= screenSizes.tabletLandscapeUp
                  ? { justifyContent: 'space-between', maxWidth: '900px' }
                  : { flexDirection: 'column', alignItems: 'center', maxWidth: '600px' }),
              }}
            >
              <div>
                <Typography tag="div" use="headline5" className="mt-3 mb-0">
                  <strong dangerouslySetInnerHTML={{ __html: wlVar('copy_lp_about_heading') }} />
                </Typography>
                <Typography tag="div" use="headline6" className="mb-3" theme="text-secondary-on-dark">
                  from {wlVar('brand_name')}
                </Typography>

                <Typography
                  tag="div"
                  className="mb-3"
                  use="subtitle1"
                  dangerouslySetInnerHTML={{ __html: wlVar('copy_lp_about_body') }}
                />

                <div>
                  <Button
                    onClick={() => newWindow(wlVar('link_href_services'), 'about-quiz')}
                    theme="secondary-bg on-secondary"
                  >
                    {wlVar('link_label_services') || 'About Our Planning Services'}
                  </Button>
                </div>
              </div>
              <div>
                <img
                  src={`${wlVar('about_image')}`}
                  width={484}
                  style={{ marginLeft: this.state.screenWidth >= screenSizes.tabletLandscapeUp ? '30px' : '0px' }}
                />
              </div>
            </div>
          </div>
        </Theme>

        {wlVar('disclosure') && (
          <div className="pt-4 pb-4" style={{ background: '#f4f4f4' }}>
            <Container>
              <div style={{ padding: '0 40px 0 40px', maxWidth: '900px', margin: 'auto' }}>
                <Typography tag="div" use="headline6" className="mb-3">
                  Disclosure
                </Typography>              
                <Typography
                  tag="div"
                  className="mb-4"
                  use="body1"
                  dangerouslySetInnerHTML={{ __html: wlVar('disclosure') }}
                />
              </div>
            </Container>
          </div>
        )}

        <div className="pt-3 pb-4" style={{ background: '#f4f4f4' }}>
          <Container>
            <div style={{ padding: '0 40px 0 40px', maxWidth: '900px', margin: 'auto' }}>
              <Typography tag="div" use="headline6" className="mb-3">
                Disclaimer
              </Typography>
              <Typography tag="div" className="mb-4" use="body1" dangerouslySetInnerHTML={{ __html: wlVar('disclaimer') }} />
              <LegalNotices />
              {isTest() &&
                this.props.user && (
                  <div className="container mt-3 text-center">
                    <Typography use="body1">
                      User: {this.props.user.id}{' '}
                      <a href="#" onClick={this._signout.bind(this)}>
                        Sign out.
                      </a>
                    </Typography>
                  </div>
                )}
              <ContactFooterShim />
            </div>
          </Container>
        </div>

        <ContactFooterFloat />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard.data,
  };
}

export default connect(mapStateToProps)(Intro);
